var _desc, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCurrentCycleRight = function SvgCurrentCycleRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "88px",
    viewBox: "0 0 34 88",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Menu-Open",
    transform: "translate(-1326.000000, -113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(1063.000000, 0.000000)",
    fill: "#FDE464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Name-Heading",
    transform: "translate(193.500000, 165.000000) scale(-1, 1) translate(-193.500000, -165.000000) translate(57.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5336846,11.3582731 L67,9.81468735 L60.5229456,0.451282051 L58.4024813,1.77351902 C46.8147679,9.00775974 33,22.2441833 33,44.2186141 C33,66.1918737 46.8170358,79.4282973 58.4058831,86.6637091 L60.551294,88 L66.8684632,78.5979465 L64.4384338,77.0766127 C51.7632737,69.1396774 44.4958645,57.1622483 44.4958645,44.2186141 C44.4958645,31.3089435 51.8006937,19.3326855 64.5336846,11.3582731",
    id: "Fill-1"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCurrentCycleRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/current_cycle_right.bf19ed14.svg";
export { ForwardRef as ReactComponent };